import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { applyTenderKey, type TenderKey } from "../tender-keypad-math";

const ROWS: TenderKey[][] = [
  ["1", "2", "3"],
  ["4", "5", "6"],
  ["7", "8", "9"],
  [".", "0", "back"],
];

/** Compact numeric pad for tender — plan/27 phone Floor. */
export function PosTenderKeypad(props: {
  value: string;
  disabled?: boolean;
  onChange: (next: string) => void;
  className?: string;
}) {
  return (
    <div
      className={cn("grid grid-cols-3 gap-1.5", props.className)}
      role="group"
      aria-label="Tender keypad"
    >
      {ROWS.flat().map((key) => (
        <Button
          key={key}
          type="button"
          variant="outline"
          className="min-h-12 text-base font-semibold tabular-nums"
          disabled={props.disabled}
          aria-label={
            key === "back" ? "Backspace" : key === "." ? "Decimal" : key
          }
          onClick={() => props.onChange(applyTenderKey(props.value, key))}
        >
          {key === "back" ? "⌫" : key}
        </Button>
      ))}
      <Button
        type="button"
        variant="ghost"
        className="col-span-3 min-h-10 text-sm"
        disabled={props.disabled || !props.value}
        onClick={() => props.onChange(applyTenderKey(props.value, "clear"))}
      >
        Clear tender
      </Button>
    </div>
  );
}
